import Link from "rivals/components/shared/Link";
import styles from "./ListBlock.module.scss";
import type { Props } from "./types";
import { getListPath } from "./utils";

/**
 * For 2024 June MVP, we're only going to put a link to the ranking list
 * page instead of rendering a rank component
 */

const philter = "list-block";

const ListBlock = ({ list }: Props): React.JSX.Element | null => {
  if (!list) {
    return null;
  }

  const listPath = getListPath(list);

  return (
    <Link
      className={styles.listLink}
      data={`${list.listType.toLowerCase()}-${philter}`}
      href={listPath}
      target="_blank"
    >
      {list.name}
    </Link>
  );
};

export default ListBlock;
